import { render, staticRenderFns } from "./DialogVcDemo.vue?vue&type=template&id=40562b76&scoped=true&"
import script from "./DialogVcDemo.vue?vue&type=script&lang=js&"
export * from "./DialogVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./DialogVcDemo.vue?vue&type=style&index=0&id=40562b76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40562b76",
  null
  
)

export default component.exports